export default __webpack_public_path__ + "static/media/chevronRight.e3d524d3.svg";